import { styled } from 'twin.macro';

import { Flex } from '@ubisend/pulse-components';

const NoSubscriber = styled(Flex)`
  height: calc(100% - 4rem);
`;

export default NoSubscriber;
